import { render, staticRenderFns } from "./ListedCompanyAnnouncement.vue?vue&type=template&id=27e5c606&scoped=true&"
import script from "./ListedCompanyAnnouncement.vue?vue&type=script&lang=js&"
export * from "./ListedCompanyAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./ListedCompanyAnnouncement.vue?vue&type=style&index=0&id=27e5c606&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e5c606",
  null
  
)

export default component.exports